import { Heading, RadioGroup } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import {
  ABOVE_GROUND_POOL_STEP_COUNT,
  IN_GROUND_POOL_STEP_COUNT,
} from "consts";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import {
  PropertyUpdatePoolContext,
  type PropertyUpdatePoolContextState,
} from ".";
import styles from "./property-update-pool.module.scss";

export const PoolBoardSlide = () => {
  const { formNavigate, state, setFields } =
    useMultiStepFormState<PropertyUpdatePoolContextState>(
      PropertyUpdatePoolContext,
    );

  const totalSteps =
    state?.poolType === "In-ground"
      ? IN_GROUND_POOL_STEP_COUNT
      : ABOVE_GROUND_POOL_STEP_COUNT;

  return (
    <MultiStepFormLayout
      step={totalSteps - 3}
      totalSteps={totalSteps}
      heading="Does your pool have a diving board?"
      buttonProps={{
        primary: {
          text: "Next",
          disabled: !state?.divingBoard || !state?.slide,
          path: "../filled",
        },
        cancel: { path: "/my/property" },
        formNavigate,
      }}
    >
      <RadioGroup
        aria-label="Pool diving board options"
        className={styles.radioGroupDS}
        defaultValue={state?.divingBoard}
        onChange={(value: "Yes" | "No") => setFields({ divingBoard: value })}
      >
        <RadioGroup.Card title="Yes" value="Yes" />
        <RadioGroup.Card title="No" value="No" />
      </RadioGroup>

      <Heading size="lg">Does your pool have a slide?</Heading>
      <RadioGroup
        aria-label="Pool slide options"
        className={styles.radioGroupDS}
        defaultValue={state?.slide}
        onChange={(value: "Yes" | "No") => setFields({ slide: value })}
      >
        <RadioGroup.Card title="Yes" value="Yes" />
        <RadioGroup.Card title="No" value="No" />
      </RadioGroup>
    </MultiStepFormLayout>
  );
};
